export function isArray(value: any): boolean {
  return value && Array.isArray(value);
}

export function isBoolean(value: any): boolean {
  return typeof value === 'boolean';
}

export function isString(value: any): boolean {
  return typeof value === 'string';
}

export function isNumber(value: any): boolean {
  return typeof value === 'number';
}

export function isPromise(value: any): boolean {
  return !!value && (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function';
}

export function isObject(value: any): boolean {
  return typeof value === 'object';
}

export function isEqual(value1: unknown, value2: unknown): boolean {
  // Identischer Wert oder beide null/undefined
  if (value1 === value2) {
    return true;
  }

  // Einer ist null/undefined, der andere nicht
  if (value1 == null || value2 == null) {
    return false;
  }

  // Date-Vergleich
  if (value1 instanceof Date && value2 instanceof Date) {
    return value1.getTime() === value2.getTime();
  }

  // Array-Vergleich
  if (Array.isArray(value1) && Array.isArray(value2)) {
    if (value1.length !== value2.length) {
      return false;
    }
    return value1.every((item, index) => isEqual(item, value2[index]));
  }

  // Objekt-Vergleich
  if (typeof value1 === 'object' && typeof value2 === 'object') {
    const keys1 = Object.keys(value1 as Record<string, unknown>);
    const keys2 = Object.keys(value2 as Record<string, unknown>);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keys1.every((key) => {
      const obj1 = value1 as Record<string, unknown>;
      const obj2 = value2 as Record<string, unknown>;
      return Object.prototype.hasOwnProperty.call(obj2, key) && isEqual(obj1[key], obj2[key]);
    });
  }

  // Primitive Werte (wurden bereits mit === verglichen)
  return false;
}

export function isDifferent(value1: unknown, value2: unknown): boolean {
  return !isEqual(value1, value2);
}
